<div layout layout-align-items-center>
  <rt-numeric-input
    [formControl]="control()"
    [disableInvalidStyles]="true"
    [placeholder]="'app.evaluation_panel.enter_salary' | translate"
    class="salary-field__input"
  />
  @if (currencyLabel()) {
    <div class="salary-field__currency" margin-left-small-x>{{ currencyLabel() }}</div>
  }
</div>
